import React, { useState, useRef, useEffect } from "react";
import cameraIcon from "./img/kamera.png";
import badExample from "./img/badEstateExample.jpg";
import goodExample from "./img/goodEstateExample.jpg";
import { Alert, Button, Col, Modal, Row } from "react-bootstrap";
import { useM365Context } from "./m365Context";
import { SpinnerGroup } from "./Utils/SpinnerGroup";

export default function FotoUpload({ sharepointFileData }) {
   const { getSharepointData, getSharepointFile, uploadFileToSharepoint } = useM365Context();

   const [show, setShow] = useState(false);
   const [selectedFiles, setSelectedFiles] = useState([]);
   const [uploading, setUploading] = useState(false);
   const [isDragging, setIsDragging] = useState(false);
   const [error, setError] = useState(null);

   const fileInputRef = useRef(null);
   const cameraInputRef = useRef(null);
   const dragCounter = useRef(0);

   const handleClose = () => {
      setShow(false);
      setError(null);
   };

   const handleShow = async () => {
      setShow(true);
   };

   // Gemeinsame Funktion für alle Datei-Quellen (Auswahl, Kamera, Drag&Drop).
   // Für Bilddateien wird zusätzlich eine Object-URL für die Vorschau erzeugt.
   function addFiles(fileList) {
      const newFiles = Array.from(fileList).map((file) => ({
         file,
         previewUrl: file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
      }));
      setSelectedFiles((prev) => [...prev, ...newFiles]);
   }

   function handleFileInputChange(event) {
      if (event.target.files?.length) {
         addFiles(event.target.files);
      }
      event.target.value = "";
   }

   function removeFile(index) {
      setSelectedFiles((prev) => {
         const removed = prev[index];
         if (removed.previewUrl) URL.revokeObjectURL(removed.previewUrl);
         return prev.filter((_, i) => i !== index);
      });
   }

   /*  async function saveFileToDevice(file) {
      
      const url = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
   } */

   function isIOS() {
      // Klassische iPhones/iPods
      if (/iPhone|iPod/.test(navigator.userAgent)) return true;

      // iPad (auch im Desktop-UA-Modus): Touch-Gerät + Mac-Plattform
      if (navigator.platform === "MacIntel" && navigator.maxTouchPoints && navigator.maxTouchPoints > 1) {
         return true;
      }

      // Fallback: klassischer iPad-UA (ältere iPadOS-Versionen)
      if (/iPad/.test(navigator.userAgent)) return true;

      return false;
   }

   async function saveFileToDevice(file) {
      const canUseShare = navigator.canShare && navigator.canShare({ files: [file] });

      if (isIOS()) {
         if (canUseShare) {
            try {
               await navigator.share({ files: [file] });
            } catch (err) {}
         }
         return;
      }

      // Android / everything else — normal download
      const url = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
   }

   async function uploadFile(file) {
      const dotIndex = file.name.lastIndexOf(".");
      const extension = dotIndex !== -1 ? file.name.slice(dotIndex + 1) : "";
      const newFileName = extension ? `Titelbild.${extension}` : "Titelbild";
      return uploadFileToSharepoint(file, sharepointFileData.driveId, sharepointFileData.parentId, newFileName);
   }

   async function handleUploadAll() {
      if (selectedFiles.length === 0) return;
      setUploading("isUploading");
      setError(null);

      try {
         for (const item of selectedFiles) {
            await uploadFile(item.file);
         }
         // Object-URLs nach erfolgreichem Upload freigeben
         selectedFiles.forEach((item) => {
            if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
         });
         setSelectedFiles([]);
      } catch (err) {
         window.alert("Beim Hochladen ist ein Fehler aufgetreten.");
         window.alert(JSON.stringify(err));
         setError("Beim Hochladen ist ein Fehler aufgetreten.");
      } finally {
         setUploading("uploadDone");
         setTimeout(() => {
            setUploading(false);
         }, 2000);
         // window.alert("Upload erfolgreich!")
      }
      try {
         for (const item of selectedFiles) {
            await saveFileToDevice(item.file);
         }
      } catch (err) {
         window.alert("Beim Runterladen ist ein Fehler aufgetreten.");
         window.alert(JSON.stringify(err));
      }
   }

   // Beim Unmount der Komponente alle noch offenen Object-URLs freigeben
   useEffect(() => {
      return () => {
         selectedFiles.forEach((item) => {
            if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
         });
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <>
         <div style={{ position: "relative" }}>
            <button
               onClick={() => {
                  handleShow();
               }}
               className="custom-group-button"
               /* style={{
                  position: "absolute",
                  
                  right: "300px",
                  zIndex: 0,
               }} */
               title="Foto hochladen"
            >
               <img src={cameraIcon} />
            </button>
         </div>
         <Modal show={show} size="xl" onHide={handleClose} dialogClassName="mt-5">
            <Modal.Header closeButton>
               <Modal.Title>Foto hochladen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               <div>
                  <Row className="justify-content-center m-2">
                     <Col xs={12} md={6} className="d-flex justify-content-center mb-md-0">
                        <div
                           style={{
                              background: "#f00",
                              overflow: "hidden",
                              borderRadius: "1rem",
                              outline: "dashed 0.3rem #c00",
                              margin: "10px",
                              width: "90%",
                           }}
                        >
                           <img style={{ width: "100%", opacity: 0.9 }} src={badExample} />
                        </div>
                     </Col>
                     <Col xs={12} md={6} className="d-flex justify-content-center">
                        <div
                           style={{
                              background: "#0f0",
                              overflow: "hidden",
                              borderRadius: "1rem",
                              outline: "solid 0.3rem #0a0",
                              margin: "10px",
                              width: "90%",
                           }}
                        >
                           <img style={{ width: "100%", objectFit: "contain", opacity: 0.95 }} src={goodExample} />
                        </div>
                     </Col>
                  </Row>
                  <div className="m-2" style={{ display: "flex", justifyContent: "center", fontSize: "x-large" }}>
                     <ul>
                        <li>Foto im Querformat</li>
                        <li>Genug Abstand halten, damit Dach und Vorgarten vollständig im Bild sind</li>
                        <li>Kamera möglichst gerade halten</li>
                        <li>Leicht seitlich statt frontal fotografieren, das zeigt Tiefe und Grundstücksbreite</li>
                        <li>Vordergrund (Weg, Rasen) mit einplanen, wirkt einladender als reine Fassade</li>
                     </ul>
                  </div>

                  <input
                     ref={cameraInputRef}
                     type="file"
                     accept="image/*"
                     capture="environment"
                     onChange={handleFileInputChange}
                     style={{ display: "none" }}
                  />
                  <Button variant="primary" className="w-100" onClick={() => cameraInputRef.current?.click()}>
                     Foto aufnehmen
                  </Button>
               </div>

               {selectedFiles.length > 0 && (
                  <ul style={{ listStyle: "none", padding: 0 }}>
                     {selectedFiles.map((item, index) => (
                        <li
                           key={`${item.file.name}-${index}`}
                           style={{
                              display: "flex",
                              alignItems: "center",
                              position: "relative",
                              gap: "10px",
                              padding: "6px 0",
                              borderBottom: "1px solid #eee",
                           }}
                        >
                           {item.previewUrl ? (
                              <img
                                 src={item.previewUrl}
                                 alt={item.file.name}
                                 style={{
                                    width: "100%",
                                    // height: "40px",
                                    // objectFit: "cover",
                                    borderRadius: "6px",
                                    flexShrink: 0,
                                 }}
                              />
                           ) : (
                              <div
                                 style={{
                                    width: "40px",
                                    height: "60px",
                                    borderRadius: "6px",
                                    background: "#eee",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "10px",
                                    flexShrink: 0,
                                    textTransform: "uppercase",
                                 }}
                              >
                                 {item.file.name.split(".").pop()}
                              </div>
                           )}
                           <span style={{ flex: 1 }}>{item.file.name}</span>
                           <button
                              style={{
                                 position: "absolute",
                                 top: 10,
                                 right: 5,
                                 padding: "15px 20px",
                                 background: "#000a",
                              }}
                              onClick={() => removeFile(index)}
                              title="Entfernen"
                           >
                              ✕
                           </button>
                        </li>
                     ))}
                  </ul>
               )}

               {error && <div style={{ color: "red", marginTop: "8px" }}>{error}</div>}
               {uploading === "uploadDone" && (
                  <Alert variant="success" className="my-1">
                     Hochladen erfolgreich!
                  </Alert>
               )}
            </Modal.Body>
            <Modal.Footer>
               <Button variant="outline-dark" className="w-100" onClick={handleClose}>
                  Abbrechen
               </Button>
               <Button
                  variant="dark"
                  className="w-100"
                  onClick={handleUploadAll}
                  disabled={uploading === "isUploading" || selectedFiles.length === 0}
               >
                  {uploading === "isUploading" ? <SpinnerGroup /> : "Hochladen"}
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
}
